import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import {
    Save,
    History
} from "@mui/icons-material";
import { styled } from '@mui/material/styles';

const StatusBox = styled(Box)(({ theme, open }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: open ? '60px' : '0px',
    overflow: 'hidden',
    transition: `width 0.3s ease-in, padding 0.3s ease-in, border-color ${open ? '0.2s' : '0.4s'} ease-in-out`,
    borderRadius: '10px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: open ? 'rgba(125, 125, 125, 1)' : 'transparent',
    padding: open ? '4px 8px 4px' : '4px 0px 4px',
}));

const StatusText = styled(Typography)(({ theme }) => ({
    fontSize: '12px',
    fontWeight: 600,
    textAlign: 'center',
    
}));

const StyledIconButton = styled(IconButton)(() => ({
    '&.MuiIconButton-root': {
        color: 'rgb(255, 255, 255)',
        '&:hover': {},
    },
    '&.Mui-disabled': {
        color: 'rgba(255, 255, 255, 0.4)',
    },
}));


function SaveButtonGroup({ disabled=true, onSaveClick=() => {}, onDiscardClick=() => {} }) {

    return (
        <Box display="flex" alignItems="center">
            <Tooltip
                title='Save'
                arrow
            >
                <StyledIconButton
                    disabled={disabled}
                    onClick={onSaveClick}
                >
                    <Save />
                </StyledIconButton>
            </Tooltip>

            <StatusBox
                open={!disabled}
            >
                <StatusText
                    color='rgb(255, 193, 7)'
                >
                    {'UNSAVED'}
                </StatusText>
            </StatusBox>

            <Tooltip 
                title='Revert'
                arrow
            >
                <StyledIconButton
                    disabled={disabled}
                    onClick={onDiscardClick}
                    sx={{
                        '&:hover': {
                            color: 'rgb(255, 146, 146)'
                        },
                    }}
                >
                    <History />
                </StyledIconButton>
            </Tooltip>
        </Box>
    );
}

export default SaveButtonGroup;